import axiosInstance from '@/libs/axios'

const initialState = {
  echopeClubBalance: null,
  loadingEchopeClubBalance: false,
}

const getters = {
  echopeClubBalance: state => state.echopeClubBalance,
  loadingEchopeClubBalance: state => state.loadingEchopeClubBalance,
  hasEchopeClubBalance: state => (state.echopeClubBalance?.balance ?? 0) > 0,
  echopeClubBalanceValue: state => state.echopeClubBalance?.balance ?? 0,
}

/* eslint-disable no-param-reassign */
const mutations = {
  SET_ECHOPE_CLUB_BALANCE(state, balance) {
    state.echopeClubBalance = balance
  },
  SET_LOADING_ECHOPE_CLUB_BALANCE(state, loading) {
    state.loadingEchopeClubBalance = loading
  },
  CLEAR_ECHOPE_CLUB_DATA(state) {
    state.echopeClubBalance = null
    state.loadingEchopeClubBalance = false
  },
}

const actions = {
  async fetchEchopeClubBalance({ commit }, customerId) {
    if (!customerId) {
      commit('SET_ECHOPE_CLUB_BALANCE', null)
      return null
    }

    try {
      commit('SET_LOADING_ECHOPE_CLUB_BALANCE', true)
      const { data } = await axiosInstance.get(
        `/api/palmbeer/clients/by-id/${customerId}/balance`
      )
      commit('SET_ECHOPE_CLUB_BALANCE', data)
      return data
    } catch (error) {
      if (error.response?.status !== 404) {
        console.error('Erro ao buscar saldo Clube echope:', error)
      }
      commit('SET_ECHOPE_CLUB_BALANCE', null)
      return null
    } finally {
      commit('SET_LOADING_ECHOPE_CLUB_BALANCE', false)
    }
  },

  clearEchopeClubData({ commit }) {
    commit('CLEAR_ECHOPE_CLUB_DATA')
  },
}

export default {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions,
}
